module.exports = __webpack_public_path__ + "img/pahs_logo.1c012f1b.jpg";